import { Link } from "react-router-dom";
import { FiChevronRight,FiX } from "react-icons/fi";
import React, { useState } from "react";
import Modal from "react-modal";

export default function Teammembers({ teammembers }) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [modalData, setMData] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  function closeModal() {
    setIsOpen(false);
    setSelectedItem(null);
  }

  function openModal(item) {
    setMData(item.data);
    setIsOpen(true);
  }

  function handleItemClick(item) {
    setSelectedItem(item);
    openModal(item);
  }

  function isModal() {
    return window.innerWidth <= 468;
  }

  function handleKeyDown(e, item) {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleItemClick(item);
    }
  }

  return (
    <>
      {teammembers.map((item, index) => {
        return (
          <div className="team" key={index}>
            <div className="team-img">
              {item.img ? (
                <button
                  type="button"
                  className="team-img-button"
                  onClick={() => handleItemClick(item)}
                  aria-label={`${item.name || "Team member"}${item.designation ? `, ${item.designation}` : ""} button`}
                >
                  <img src={item.img} alt={item.name || "Team member"} />
                </button>
              ) : (
                ""
              )}
              {item.socials ? (
                <div className="socials">
                  {item.socials.map((social, i) => (
                    <a
                      key={i}
                      href={social.url}
                      aria-label={`LinkedIn of ${item.name || "Team member"}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="social-link"
                      onClick={(e) => e.stopPropagation()}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.stopPropagation();
                        }
                      }}
                    >
                      <span aria-hidden="true">{social.icon}</span>
                    </a>
                  ))}
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="team-content">
              {item.name && (
                <div
                  className="name-container"
                  onClick={() => handleItemClick(item)}
                  onKeyDown={(e) => handleKeyDown(e, item)}
                  tabIndex="0"
                  role="button"
                  aria-label={`${item.name}${item.designation ? `, ${item.designation}` : ""} button`}
                  style={{ cursor: "pointer" }}
                >
                  <h2 className="name">{item.name}</h2>
                </div>
              )}
              {item.designation && <p className="designation">{item.designation}</p>}
              {modalData && (
                <Modal
                  style={{
                    overlay: {
                      backgroundColor: "rgba(30, 30, 30, 0.3)",
                      zIndex: "9",
                    },
                    content: {
                      top: isModal() ? "60%" : "50%",
                      left: "50%",
                      right: "auto",
                      bottom: isModal() ? "-10%" : "auto",
                      marginRight: "-50%",
                      transform: "translate(-50%, -50%)",
                      maxWidth: isModal() ? "100%" : "600px",
                      cursor: "pointer",
                    },
                  }}
                  isOpen={modalIsOpen}
                  onRequestClose={closeModal}
                  shouldCloseOnEsc={true}
                  contentLabel={`${selectedItem?.name || "Team member"} details`}
                >
                  {isModal() && (
                    <button
                      onClick={closeModal}
                      aria-label="Close modal"
                      style={{
                        position: "absolute",
                        top: "5px",
                        right: "5%",
                        cursor: "pointer",
                        background: "none",
                        border: "none",
                        padding: "0",
                        outline: "2px solid transparent",
                        outlineOffset: "2px",
                        borderRadius: "4px",
                      }}
                      onFocus={(e) => e.target.style.outline = "2px solid var(--primary_color)"}
                      onBlur={(e) => e.target.style.outline = "2px solid transparent"}
                    >
                      <FiX size={24} aria-hidden="true" />
                    </button>
                  )}
                  {modalData.map((i, index) => (
                    <p
                      style={{

                        marginBottom: "15px",
                        fontSize: "14px",
                        color: "#677286",
                        fontWeight: 500,
                      }}
                      key={index}
                    >
                      {i}
                    </p>
                  ))}

                </Modal>
              )}
            </div>
          </div>
        );
      })}
    </>
  );
}
